exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#aa-video-ad-unit .upper-controls .countdown[data-can-skip=\"true\"] {\n  float: left;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Display/Components/UpperControls/Countdown.css
// module id = 170
// module chunks = 6